module.exports = __webpack_public_path__ + "media/images/placeholders/psychiatrische-sprechstunde-ef5fb1907291d74c9b0d334ea437a71d.jpg";